module.exports = __webpack_public_path__ + "media/brand_logos/namibia-breweries-limited-07c18179.png";